import { render, staticRenderFns } from "./DataEmpCustom1.vue?vue&type=template&id=6752c06b"
import script from "./DataEmpCustom1.vue?vue&type=script&lang=ts"
export * from "./DataEmpCustom1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports